import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class PriceComponent extends Component {
  render() {
    const data = this.props.data;
    return <span>{(data / 100).toFixed(2)} PLN</span>;
  }
}

export default class Table extends Component {
  render() {
    const {
      products
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "name",
        displayName: "Nazwa produktu",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "unitPrice",
        displayName: "Cena za sztukę",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: PriceComponent
      },
      {
        columnName: "quantity",
        displayName: "Ilość",
        cssClassName: "table-unsortable",
        visible: true
      }
    ];

    let data = [];

    if (products) {
      products.toJS().forEach(function(product, index) {
        product.index = index + 1;
        data = data.concat(product);
      });
    }

    return (
      <Griddle
        results={data}
        columnMetadata={columnMetadata}
        tableClassName="data-table"
        useGriddleStyles={false}
        columns={["index", "name", "unitPrice", "quantity"]}
        enableSort={false}
        enableInfiniteScroll={false}
        showPager={false}
        bodyHeight={100}
        resultsPerPage={100}
        noDataMessage={"Brak danych"}
        sortAscendingComponent={
          <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
        }
        sortDescendingComponent={
          <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/order/table.react.js